/* Just4Crew · compra desde las secciones propias (DESIGN.md v2.2–v2.5).
   Habla el idioma del tema: POST a cart_add_url con `sections` del cajón y CartAddEvent de @theme/events,
   así la burbuja y el cajón se enteran igual que desde la ficha. La compra nunca espera a una animación. */
import { CartAddEvent, ThemeEvents } from '@theme/events';

const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];
const money = (cents) => `AED ${(cents / 100).toLocaleString('en-US', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 })}`;

/* ---------- agregar al carrito (el fetch es lo único que cobra; lo demás va en su propio try) ---------- */
async function addToCart(items, { button, batch = false } = {}) {
  const sectionId = $('cart-items-component')?.dataset.sectionId;
  const addUrl = (window.Theme?.routes?.cart_add_url) || '/cart/add';
  let lastResponse = null;
  if (batch) {
    const url = addUrl.replace(/(?:\.js)?$/, '.js');
    const r = await fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items, ...(sectionId ? { sections: sectionId } : {}) }),
    });
    lastResponse = await r.json();
    if (!r.ok || lastResponse.status) throw new Error(lastResponse.description || lastResponse.message || 'Could not add your pack. Please try again.');
  } else for (let i = 0; i < items.length; i++) {
    const fd = new FormData();
    fd.append('id', items[i].id);
    fd.append('quantity', items[i].quantity || 1);
    if (sectionId && i === items.length - 1) fd.append('sections', sectionId);
    const r = await fetch(addUrl, { method: 'POST', headers: { Accept: 'application/javascript' }, body: fd });
    lastResponse = await r.json();
    if (lastResponse.status) throw new Error(lastResponse.description || lastResponse.message || 'cart error');
  }
  try {
    document.dispatchEvent(new CartAddEvent({}, 'j4c', {
      source: 'j4c-quick-add',
      itemCount: items.reduce((a, x) => a + (x.quantity || 1), 0),
      variantId: String(items[items.length - 1].id),
      sections: lastResponse?.sections,
    }));
    const drawer = $('cart-drawer-component');
    if (drawer && !drawer.hasAttribute('auto-open')) drawer.open?.();
    if (button) {
      const prev = button.textContent;
      button.textContent = 'Added';
      button.classList.add('j4c-added');
      setTimeout(() => { if (button.textContent === 'Added') button.textContent = prev; button.classList.remove('j4c-added'); }, 1400);
    }
  } catch (e) { /* la compra ya está hecha: un fallo del gesto no se vuelve error rojo */ }
}

/* ---------- panel de variante (el color llega preseleccionado; la talla NUNCA) ---------- */
function productData(host) {
  /* la tarjeta trae su JSON; las tarjetas de tono (ficha v5) comparten uno por sección (data-j4c-group) */
  const node = $('script[data-j4c-product]', host) || host.closest('[data-j4c-group]')?.querySelector('script[data-j4c-product]');
  try { return node ? JSON.parse(node.textContent) : null; } catch { return null; }
}
function panelFor(card, data, colorPedido) {
  $$('.j4c-vpanel').forEach((x) => x.remove());
  /* 2-nov: Shopify deja S/M y L/XL al final de las tallas; aquí van en su orden */
  const ORDEN = ['S', 'S/M', 'M', 'L', 'L/XL', 'XL', 'XXL'];
  data.options.forEach((o) => { if (o.values.every((v) => ORDEN.includes(v))) o.values.sort((a, b) => ORDEN.indexOf(a) - ORDEN.indexOf(b)); });
  const sel = data.options.map((o) => (o.values.length === 1 ? o.values[0] : null));
  const ci = data.options.findIndex((o) => /colou?r/i.test(o.name));
  const tonoFijo = ci > -1 && !!colorPedido && data.options[ci].values.includes(colorPedido);
  if (tonoFijo) sel[ci] = colorPedido;
  /* con el tono ya elegido (tarjeta de tono) la fila de colores sobra: queda talla + botón */
  const opts = data.options.filter((o, i) => o.values.length > 1 && !(tonoFijo && i === ci));
  const nombre = (o) => (/size/i.test(o.name) ? 'size' : o.name.toLowerCase());
  if (ci > -1 && !sel[ci]) {
    sel[ci] = data.options[ci].values.find((v) => data.variants.some((x) => x.available && x.options[ci] === v)) || data.options[ci].values[0];
  }
  /* 2-nov: medias 60 / 30 den en un producto: el grosor llega puesto (60) y sólo salen tonos y tallas que existen en ese grosor */
  const di = data.options.findIndex((o) => /denier/i.test(o.name));
  if (di > -1 && !sel[di]) sel[di] = data.options[di].values[0];
  const existe = (i, val) => {
    if (di < 0) return true;
    /* con el tono fijo (tarjeta de tono), el grosor que no lo tiene no se ofrece */
    if (i === di) return !tonoFijo || data.variants.some((v) => v.options[di] === val && v.options[ci] === sel[ci]);
    return data.variants.some((v) => v.options[i] === val && v.options[di] === sel[di]);
  };
  const variantFor = () => data.variants.find((v) => v.options.every((o, i) => o === sel[i]));
  const ok = (i, val) => data.variants.some((v) => v.available && v.options[i] === val && v.options.every((x, j) => j === i || !sel[j] || x === sel[j]));
  const panel = document.createElement('div');
  panel.className = 'j4c-vpanel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'Choose options');
  const draw = () => {
    const v = sel.every(Boolean) ? variantFor() : null;
    const missing = data.options.filter((o, i) => !sel[i]).map(nombre);
    const cabeza = missing.length ? (tonoFijo ? colorPedido + ' · choose ' + missing.join(' and ') : 'Choose ' + missing.join(' and ')) : v.title;
    panel.innerHTML = `<div class="j4c-vp-h"><span>${cabeza}</span><button type="button" class="j4c-vp-x" aria-label="Close">×</button></div>`
      + opts.map((o) => {
        const i = data.options.indexOf(o);
        return `<div class="j4c-row" role="radiogroup" aria-label="${o.name}">` + o.values.filter((val) => existe(i, val)).map((val) => (
          /colou?r/i.test(o.name)
            ? `<button type="button" class="j4c-shade" role="radio" aria-checked="${sel[i] === val}" aria-label="${val}" title="${val}" data-i="${i}" data-v="${val}"><i style="background:${data.swatches[val] || '#ccc'}"></i></button>`
            : `<button type="button" class="j4c-size" role="radio" aria-checked="${sel[i] === val}" data-i="${i}" data-v="${val}" ${ok(i, val) ? '' : 'disabled'}>${val}</button>`
        )).join('') + '</div>';
      }).join('')
      + `<button type="button" class="j4c-btn j4c-btn--primary j4c-go" style="width:100%" ${v && v.available ? '' : 'disabled'}>${v ? (v.available ? 'Add to bag, ' + money(v.price) : 'Sold out') : 'Choose ' + missing.join(' and ')}</button>`;
    $$('[data-i]', panel).forEach((b) => b.addEventListener('click', (e) => {
      e.stopPropagation();
      sel[+b.dataset.i] = b.dataset.v;
      if (+b.dataset.i === di) sel.forEach((val, i) => { if (val && !existe(i, val)) sel[i] = i === ci && !tonoFijo ? data.options[ci].values.find((x) => existe(ci, x)) : null; });
      draw();
    }));
    $('.j4c-vp-x', panel).addEventListener('click', (e) => { e.stopPropagation(); panel.remove(); });
    const go = $('.j4c-go', panel);
    if (v && v.available) go.addEventListener('click', (e) => { e.stopPropagation(); panel.remove(); addToCart([{ id: v.id }], { button: $('.j4c-buy', card) }); });
  };
  draw();
  card.append(panel);
}
document.addEventListener('click', (e) => {
  const q = e.target.closest('[data-j4c-quick]');
  if (q) {
    e.preventDefault();
    const card = q.closest('[data-j4c-card]') || q.parentElement;
    const data = productData(card);
    if (!data) return;
    const needs = data.options.some((o) => o.values.length > 1);
    const live = data.variants.filter((v) => v.available);
    if (!needs && live[0]) { addToCart([{ id: live[0].id }], { button: q }); return; }
    panelFor(card, data, q.dataset.j4cColor);
    return;
  }
  if (!e.target.closest('.j4c-vpanel')) $$('.j4c-vpanel').forEach((x) => x.remove());
});

/* ---------- kit con casillas: todo entra con un botón ---------- */
function kitDraw(root) {
  const rows = $$('[data-j4c-kit-item]', root);
  let total = 0; let n = 0;
  rows.forEach((row) => {
    const on = $('input[type=checkbox]', row).checked;
    const sel = $('select', row);
    const price = +((sel ? sel.selectedOptions[0]?.dataset.price : row.dataset.price) || 0);
    if (on) { total += price; n += 1; }
  });
  $('[data-j4c-kit-n]', root).textContent = `${n} ${n === 1 ? 'item' : 'items'}`;
  $('[data-j4c-kit-total]', root).textContent = money(total);
  $('[data-j4c-kit-add]', root).disabled = !n;
}
$$('[data-j4c-kit]').forEach((root) => {
  root.addEventListener('change', () => kitDraw(root));
  kitDraw(root);
  $('[data-j4c-kit-add]', root).addEventListener('click', function () {
    const items = $$('[data-j4c-kit-item]', root)
      .filter((row) => $('input[type=checkbox]', row).checked)
      .map((row) => ({ id: +($('select', row) ? $('select', row).value : row.dataset.variant) }));
    if (items.length) addToCart(items, { button: this });
  });
});

/* ---------- cajón v5.8: el bloque de la promo agrega con un botón (data-j4c-add = [{id, quantity}]) ---------- */
document.addEventListener('click', async (e) => {
  const b = e.target.closest('[data-j4c-add]');
  if (!b || b.disabled) return;
  e.preventDefault();
  let items;
  try { items = JSON.parse(b.dataset.j4cAdd); } catch { return; }
  b.disabled = true;
  try { await addToCart(items, { button: b, batch: true }); } catch (err) { b.textContent = 'Please try again'; }
  b.disabled = false;
});

/* ---------- fecha de entrega en UAE (DESIGN.md v5.8 · 6), en hora de Dubái (UTC+4, sin horario de verano) ---------- */
const J4C_FERIADOS = [];   // 'YYYY-MM-DD' en los que no se despacha ni se entrega (Eid, 2–3 dic): agregarlos antes de cada uno
(() => {
  const host = $('[data-j4c-eta]');
  if (!host) return;
  const DIA = 864e5;
  const iso = (d) => d.toISOString().slice(0, 10);
  const entrega = (d) => d.getUTCDay() !== 0 && !J4C_FERIADOS.includes(iso(d));               // lunes a sábado
  const despacho = (d) => d.getUTCDay() >= 1 && d.getUTCDay() <= 5 && !J4C_FERIADOS.includes(iso(d));   // lunes a viernes
  const siguiente = (d, ok) => { let x = new Date(+d + DIA); while (!ok(x)) x = new Date(+x + DIA); return x; };
  const habiles = (d, n) => { let x = d; for (let i = 0; i < n; i++) x = siguiente(x, entrega); return x; };
  const fecha = (d) => d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
  const pintar = () => {
    const ahora = new Date(Date.now() + 4 * 36e5);                 // campos UTC = reloj de Dubái
    const hoy = new Date(Date.UTC(ahora.getUTCFullYear(), ahora.getUTCMonth(), ahora.getUTCDate()));
    const min = ahora.getUTCHours() * 60 + ahora.getUTCMinutes();
    let t;
    if (despacho(hoy) && min < 11 * 60) {
      const falta = 11 * 60 - min;
      const reloj = [Math.floor(falta / 60) && `${Math.floor(falta / 60)}h`, falta % 60 && `${falta % 60}m`].filter(Boolean).join(' ');
      t = `Order within <b>${reloj}</b> and get it <b>tomorrow, ${fecha(siguiente(hoy, entrega))}</b>`;
    } else if (despacho(hoy)) {
      const sale = min < 14 * 60 ? hoy : siguiente(hoy, despacho);
      t = `Arrives <b>${fecha(habiles(sale, 2))} – ${fecha(habiles(sale, 3))}</b>`;
    } else {
      t = `Order now and get it <b>${fecha(siguiente(siguiente(hoy, despacho), entrega))}</b>`;   // sale el lunes, llega el martes
    }
    $('[data-j4c-eta-t]', host).innerHTML = t;
    host.hidden = false;
  };
  pintar();
  setInterval(pintar, 30000);
})();

/* ---------- Joining Kit (DESIGN.md v5.9 · 4): un tono y una talla por fila, total en vivo, todo entra con un botón ---------- */
$$('[data-j4c-join]').forEach((card) => {
  const rows = $$('[data-j4c-join-row]', card).map((row) => ({
    qty: +row.dataset.qty,
    modo: row.dataset.modo,
    variants: JSON.parse($('[data-j4c-join-variants]', row).textContent),
    selects: $$('select', row),
    opt: $('[data-j4c-join-opt]', row),
    img: $('img', row),
    was: $('[data-j4c-join-was]', row),
  }));
  const button = $('[data-j4c-join-add]', card);
  const total = $('[data-j4c-join-total]', card);
  const elegido = (r) => {
    if (!r.selects.length) return r.variants.find((v) => v.available) || false;
    const vals = r.selects.map((s) => s.value);
    if (vals.some((v) => !v)) return null;
    return r.variants.find((v) => v.available && v.options.every((o, i) => o === vals[i])) || false;
  };
  const activas = () => rows.filter((r) => r.modo !== 'opcional' || r.opt?.checked);
  const draw = () => {
    let suma = 0;
    let falta = false;
    let agotado = false;
    rows.forEach((r) => r.selects.forEach((s) => s.classList.remove('j4c-falta')));
    activas().forEach((r) => {
      const v = elegido(r);
      if (v === null) { falta = true; r.selects.forEach((s) => { if (!s.value) s.classList.add('j4c-falta'); }); }
      else if (v === false) agotado = true;
      if (v && v.img && r.img && r.img.getAttribute('src') !== v.img) r.img.src = v.img;   /* v5.21: el regalo enseña la foto de lo elegido */
      if (v && v.was && r.was) r.was.textContent = money(v.was);   /* v5.22: y su precio real, tachado */
      if (r.modo !== 'gratis') suma += (v ? v.price : r.variants[0].price) * (r.modo === 'cinco' ? r.qty - 1 : r.qty);   /* v5.30: 5 pares, el 5º gratis */
    });
    total.textContent = money(suma);
    button.textContent = falta ? 'Choose size' : agotado ? 'Not available in that choice' : `Add kit to bag · ${money(suma)}`;
    button.disabled = falta || agotado;
  };
  card.addEventListener('change', draw);
  button.addEventListener('click', async () => {
    const items = activas().map((r) => ({ id: elegido(r).id, quantity: r.qty }));
    button.disabled = true;
    try {
      await addToCart(items, { button, batch: true });
      card.closest('dialog')?.close();   /* v5.16: se cierra la hoja para que se vea el cajón */
    } catch (e) { button.textContent = 'Please try again'; }
    setTimeout(draw, 1500);
  });
  draw();
});

/* ---------- Joining Kit v5.16: la tarjeta abre su hoja (dialog nativo: Escape y foco los da el navegador) ---------- */
document.addEventListener('click', (e) => {
  const abrir = e.target.closest('[data-j4c-join-open]');
  if (abrir) { abrir.closest('.j4c-joincard, .j4c-kitcard')?.querySelector('[data-j4c-joinsheet]')?.showModal(); return; }
  if (e.target.closest('[data-j4c-joinsheet-x]')) { e.target.closest('dialog')?.close(); return; }
  if (e.target instanceof HTMLDialogElement && e.target.matches('[data-j4c-joinsheet]')) e.target.close();   // toque fuera de la hoja
});

/* ---------- etiquetas sobre la foto grande de la ficha (v5.9 · 3) ---------- */
(() => {
  const src = $('[data-j4c-tags-pdp]');
  const host = $('.product-information media-gallery slideshow-container') || $('.product-information media-gallery');
  if (!src || !host || !src.firstElementChild) return;
  host.classList.add('j4c-gal-tags');
  host.prepend(src.firstElementChild);
})();

/* ---------- el avión del menú (DESIGN.md v5.9 · 8): port del limelight de dejadetrabajar.com, con un avión en vez de la luz ---------- */
/* 2026-10-20: el header-menu de Horizon re-pinta su interior al iniciar y se llevaba el avión. Por eso: el contenedor y los enlaces
   se buscan en cada vuelo, el avión se re-engancha si desaparece, y el cursor se escucha delegado en el documento. */
if (matchMedia('(min-width: 750px)').matches) {
  const SEL = '#header-group header-menu .header-menu__inner';
  const plane = document.createElement('span');
  plane.className = 'j4c-navplane';
  plane.setAttribute('aria-hidden', 'true');
  plane.innerHTML = '<span class="j4c-navplane__in"><i></i><i></i><i></i><svg viewBox="0 0 24 24" width="18" height="18"><path transform="rotate(90 12 12)" d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/></svg></span>';
  const enlaces = () => { const h = $(SEL); return h ? $$('a', h).filter((a) => (a.getAttribute('href') || '').startsWith('/')) : []; };
  const activo = () => {
    const ls = enlaces();
    const exacto = ls.findIndex((a) => { const h = a.getAttribute('href'); return !h.includes('#') && location.pathname.startsWith(h); });
    if (exacto >= 0) return exacto;
    /* v5.13: en otra colección o ficha se posa en «Shop», que es donde vive */
    return /^\/(collections|products)\//.test(location.pathname) ? ls.findIndex((a) => a.getAttribute('href') === '/collections/all') : -1;
  };
  let x = null;
  let alto = 0;
  const volar = (i, animar = true) => {
    const host = $(SEL);
    const a = enlaces()[i];
    if (!host) return;
    if (plane.parentNode !== host) { host.append(plane); x = null; }
    if (!a) { plane.classList.remove('lit'); return; }
    const caja = host.getBoundingClientRect();
    const r = a.getBoundingClientRect();
    const nx = r.left - caja.left + r.width / 2 - 9;
    if (x !== null && nx !== x) plane.style.setProperty('--dir', nx < x ? -1 : 1);
    const salto = !animar || x === null;
    if (salto) plane.style.transition = 'none';
    plane.style.transform = `translateX(${nx}px)`;
    if (!salto && nx !== x) {
      plane.classList.add('moving');
      clearTimeout(alto);
      alto = setTimeout(() => plane.classList.remove('moving'), 480);
    }
    x = nx;
    plane.classList.add('lit');
    if (salto) requestAnimationFrame(() => requestAnimationFrame(() => { plane.style.transition = ''; }));
  };
  let actual = -1;
  document.addEventListener('pointerover', (e) => {
    const a = e.target.closest?.(`${SEL} a`);
    if (!a) return;
    const i = enlaces().indexOf(a);
    if (i >= 0 && i !== actual) { actual = i; volar(i); }
  });
  const regresar = () => {
    if ($('.j4c-mega.open') || $(SEL)?.matches(':hover')) return;
    actual = activo();
    volar(actual);
  };
  document.addEventListener('pointerout', (e) => { if (e.target.closest?.(SEL)) setTimeout(regresar, 150); });
  const mega = $('.j4c-mega');   // sección propia: Horizon no la re-pinta
  if (mega) new MutationObserver(() => { if (!mega.classList.contains('open')) setTimeout(regresar, 150); }).observe(mega, { attributes: true, attributeFilter: ['class'] });
  addEventListener('resize', () => volar(actual, false));
  const iniciar = () => { actual = activo(); volar(actual, false); };
  if (document.readyState === 'complete') setTimeout(iniciar, 300); else addEventListener('load', () => setTimeout(iniciar, 300));
}

/* ---------- carriles con flechas ---------- */
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-j4c-dir]');
  if (!b) return;
  const rail = $('.j4c-rail', b.closest('.j4c-sec'));
  if (rail) rail.scrollBy({ left: (b.dataset.j4cDir === 'prev' ? -1 : 1) * rail.clientWidth * 0.8, behavior: 'smooth' });
});

/* ---------- revelado mínimo por BARRIDO (un observador no ve los saltos con ancla) ---------- */
if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.documentElement.classList.add('j4c-rv');
  let queued = false;
  const sweep = () => {
    queued = false;
    const limit = innerHeight * 0.92;
    $$('.j4c-rv:not(.j4c-in)').forEach((el) => { if (el.getBoundingClientRect().top < limit) el.classList.add('j4c-in'); });
  };
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(sweep); } };
  requestAnimationFrame(() => requestAnimationFrame(sweep));
  addEventListener('scroll', queue, { passive: true });
  addEventListener('resize', queue);
  addEventListener('hashchange', () => setTimeout(sweep, 50));
  addEventListener('load', queue);
}

/* ---------- ficha v3: «Add also» entra con el MISMO botón (escucha el add nativo del tema) ---------- */
let extrasEnVuelo = false;
document.addEventListener(CartAddEvent.eventName, (e) => {
  const d = e.detail?.data || {};
  if (d.source !== 'product-form-component' || d.didError || extrasEnVuelo) return;
  const filas = $$('[data-j4c-extra]').filter((row) => $('input[type=checkbox]', row).checked);
  if (!filas.length) return;
  const items = filas.map((row) => ({ id: +($('select', row) ? $('select', row).value : row.dataset.variant) })).filter((x) => x.id);
  filas.forEach((row) => { $('input[type=checkbox]', row).checked = false; });
  extrasEnVuelo = true;
  addToCart(items).finally(() => { extrasEnVuelo = false; });
});

/* ---------- packs de medias: una petición y el mismo aviso al cajón ---------- */
class J4cBuybox extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.data = JSON.parse($('[data-j4c-pack-data]', this).textContent);
    this.details = this.closest('.product-details');
    this.scope = this.closest('.shopify-section');
    this.variant = this.data.variants.find((v) => String(v.id) === this.dataset.variant);
    this.shadeIndex = this.data.options.findIndex((o) => /colou?r|shade/i.test(o));
    this.sizeIndex = this.data.options.findIndex((o) => /size/i.test(o));
    /* 2-nov: la 60 den también trae la 30 den (opción Denier): cada par elige grosor, tono y talla, en ese orden. */
    this.denIndex = this.data.options.findIndex((o) => /denier/i.test(o));
    this.rows = [];
    /* 2.0: custom = ya eligió tono/talla por par; open = lista de pares abierta. */
    this.custom = false;
    this.open = false;
    this.count = +$('input:checked', this).value;
    this.controller = new AbortController();
    const { signal } = this.controller;
    $('[data-j4c-pack-toggle]', this).addEventListener('click', () => {
      this.open = !this.open;
      this.toggleRows();
    }, { signal });
    this.addEventListener('change', (e) => {
      if (e.target.matches('input[type=radio]')) {
        if (this.count === 1) { this.rows = []; this.custom = false; }
        this.count = +e.target.value;
        this.draw();
      }
    }, { signal });
    this.scope?.addEventListener(ThemeEvents.variantUpdate, (e) => {
      if (String(e.detail?.data?.productId || e.detail?.data?.newProduct?.id) !== this.dataset.productId) return;
      const variant = this.data.variants.find((v) => String(v.id) === String(e.detail?.resource?.id));
      if (!variant) return;
      this.variant = variant;
      /* Sin elección por par, todos los pares siguen a la variante nativa; si ya eligió, se conservan. */
      if (!this.custom && variant.available) {
        this.rows = [];
        this.draw();
        return;
      }
      this.prices();
    }, { signal });
    $('[data-j4c-pack-add]', this).addEventListener('click', () => this.add(), { signal });
    /* Un envío nativo indirecto lleva al pack, sin comprar una sola pareja. */
    this.details?.addEventListener('submit', (e) => {
      if (this.count === 1 || !e.target.closest('product-form-component')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      this.scrollToPack();
    }, { capture: true, signal });
    this.draw();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.details?.classList.remove('j4c-pack-active');
    this.ready = false;
  }

  prices() {
    $$('[data-j4c-pack-price]', this).forEach((el) => {
      el.textContent = this.variant.prices[el.dataset.j4cPackPrice];
    });
    $$('[data-j4c-pack-ship]', this).forEach((el) => {
      el.textContent = this.variant.ship[el.dataset.j4cPackShip];
    });
    $$('[data-j4c-pack-was]', this).forEach((el) => { el.textContent = this.variant.was[el.dataset.j4cPackWas]; });
    $$('[data-j4c-pack-each]', this).forEach((el) => { el.textContent = this.variant.each[el.dataset.j4cPackEach]; });
  }

  /* «Latte · S» si todos son iguales; si no, «2 Latte S, 3 Ristretto M». */
  summary() {
    const el = $('[data-j4c-pack-summary]', this);
    if (!el || !this.rows.length) return;
    const label = (v) => [v.options[this.denIndex], v.options[this.shadeIndex], v.options[this.sizeIndex]].filter(Boolean).join(' · ');
    const groups = new Map();
    this.rows.forEach((v) => groups.set(label(v), (groups.get(label(v)) || 0) + 1));
    el.textContent = groups.size === 1
      ? `All ${this.count} in ${[...groups.keys()][0]}`
      : [...groups].map(([name, n]) => `${n} × ${name}`).join(', ');
  }

  toggleRows() {
    const button = $('[data-j4c-pack-toggle]', this);
    $('[data-j4c-pack-rows]', this).hidden = !this.open;
    button.setAttribute('aria-expanded', String(this.open));
    button.textContent = this.open ? 'Done' : 'Choose per pair';
  }

  scrollToPack() {
    this.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
    $('input:checked', this)?.focus({ preventScroll: true });
  }

  draw() {
    const active = this.count !== 1;
    this.details?.classList.toggle('j4c-pack-active', active);
    $('[data-j4c-pack-ui]', this).hidden = !active;
    const gift = $('[data-j4c-gift]', this);
    if (gift) gift.hidden = this.count !== 5;   /* v5.20: con el 4 + 1 va el regalo para los zapatos, que se elige */
    this.prices();
    const button = $('[data-j4c-pack-add]', this);
    button.textContent = `Add ${this.count} pairs to bag`;
    const error = $('[data-j4c-pack-error]', this);
    error.textContent = '';
    const available = this.data.variants.filter((v) => v.available);
    const initial = this.variant?.available ? this.variant : available[0];
    /* 2026-10-20 (v5.7): un regalo agotado ya no bloquea el pack; la tarjeta deja de anunciarlo y el pack se vende igual. */
    button.disabled = !initial;
    if (active && button.disabled) error.textContent = 'This pack is currently sold out.';
    if (!active) return;
    this.rows = this.rows.slice(0, this.count);
    while (initial && this.rows.length < this.count) this.rows.push(initial);
    const host = $('[data-j4c-pack-rows]', this);
    host.replaceChildren();
    this.rows.forEach((variant, rowIndex) => {
      const row = document.createElement('fieldset');
      row.className = 'j4c-buybox__row';
      const legend = document.createElement('legend');
      legend.textContent = `Pair ${rowIndex + 1}`;
      row.append(legend);
      const selects = [];
      const order = [[this.denIndex, 'Denier'], [this.shadeIndex, 'Shade'], [this.sizeIndex, 'Size']].filter(([index]) => index >= 0);
      /* Un valor se puede elegir si existe disponible con lo ya elegido en los selectores de antes (grosor → tono → talla). */
      const refresh = () => {
        const chosen = this.rows[rowIndex];
        selects.forEach(({ select, index }, k) => {
          const before = order.slice(0, k).map(([i]) => i);
          [...select.options].forEach((option) => {
            const ok = available.some((v) => v.options[index] === option.value
              && before.every((i) => v.options[i] === chosen.options[i]));
            option.disabled = !ok;
            option.hidden = !ok && this.denIndex >= 0 && index !== this.denIndex;
          });
          select.value = chosen.options[index];
        });
      };
      order.forEach(([index, title]) => {
        const label = document.createElement('label');
        label.append(document.createTextNode(title));
        const select = document.createElement('select');
        const ORDEN = ['S', 'S/M', 'M', 'L', 'L/XL', 'XL', 'XXL'];
        const valores = [...new Set(this.data.variants.map((v) => v.options[index]))];
        if (valores.every((v) => ORDEN.includes(v))) valores.sort((a, b) => ORDEN.indexOf(a) - ORDEN.indexOf(b));
        valores.forEach((value) => {
          select.add(new Option(value, value));
        });
        select.value = variant.options[index];
        select.addEventListener('change', () => {
          const previous = this.rows[rowIndex];
          const matches = available.filter((v) => v.options[index] === select.value);
          /* La que comparte más opciones con el par anterior (mismo tono y talla si existen). */
          const score = (v) => v.options.filter((o, i) => o === previous.options[i]).length;
          const next = matches.sort((x, y) => score(y) - score(x))[0];
          if (next) this.rows[rowIndex] = next;
          this.custom = true;
          refresh();
          this.summary();
        });
        label.append(select);
        row.append(label);
        selects.push({ select, index });
      });
      refresh();
      host.append(row);
    });
    this.summary();
    this.toggleRows();
  }

  async add() {
    const button = $('[data-j4c-pack-add]', this);
    if (button.disabled || this.count === 1) return;
    const error = $('[data-j4c-pack-error]', this);
    error.textContent = '';
    const extras = $$('[data-j4c-extra]', this.details).filter((row) => $('input[type=checkbox]', row).checked);
    const items = new Map();
    const include = (id) => {
      if (id) items.set(+id, { id: +id, quantity: (items.get(+id)?.quantity || 0) + 1 });
    };
    this.rows.forEach((v) => include(v.id));
    if (this.count === 5) include($('[data-j4c-gift-select]', this)?.value || this.data.regalo);
    extras.forEach((row) => include($('select', row)?.value || row.dataset.variant));
    button.disabled = true;
    this.setAttribute('aria-busy', 'true');
    /* Bloquear cambios mientras se envía evita que el botón anuncie otro pack. */
    const controls = $$('input, select', this);
    controls.forEach((control) => { control.disabled = true; });
    try {
      await addToCart([...items.values()], { button, batch: true });
      extras.forEach((row) => { $('input[type=checkbox]', row).checked = false; });
    } catch (e) {
      error.textContent = e.message || 'Could not add your pack. Please try again.';
    } finally {
      button.disabled = false;
      controls.forEach((control) => { control.disabled = false; });
      this.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('j4c-buybox')) customElements.define('j4c-buybox', J4cBuybox);

/* ---------- barra fija de la ficha: dispara el form NATIVO, nunca reimplementa la compra ---------- */
(() => {
  const bar = $('[data-j4c-sticky]');
  if (!bar) return;
  const nativo = $('product-form-component button[type="submit"]');
  if (!nativo) return;
  const details = bar.closest('.product-details');
  const pack = details?.querySelector('j4c-buybox');
  /* 2026-10-20: posición en cada scroll, no IntersectionObserver. Con el pack de 5 el botón carga bajo el pliegue y, si la
     página salta por encima de él (guía de tallas, ancla, deslizamiento rápido), el observer no ve el cruce y la barra no
     aparecía nunca. La barra se ve cuando el botón quedó arriba de la pantalla. */
  const target = () => (pack && pack.count !== 1 ? $('[data-j4c-pack-add]', pack) : nativo);
  let frame = 0;
  const observe = () => {
    frame = 0;
    bar.hidden = target().getBoundingClientRect().bottom > 0;
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(observe); };
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  observe();
  pack?.addEventListener('change', schedule);
  $('[data-j4c-sticky-add]', bar).addEventListener('click', () => {
    if (pack && pack.count !== 1) { pack.scrollToPack(); return; }
    const form = nativo.closest('form');
    if (form) form.requestSubmit(nativo);
  });
})();

/* ---------- diálogos (guía de tallas) ---------- */
document.addEventListener('click', (e) => {
  const abre = e.target.closest('[data-j4c-dialog]');
  if (abre) { document.getElementById(abre.dataset.j4cDialog)?.showModal(); return; }
  if (e.target.closest('[data-j4c-dialog-close]')) { e.target.closest('dialog')?.close(); return; }
  if (e.target instanceof HTMLDialogElement && e.target.classList.contains('j4c-dialog')) e.target.close();
});

/* ---------- 2-nov: piezas de la ficha que dependen de la variante (medias 60 / 30 den) ----------
   El tema ya trae el HTML de la variante nueva en el evento; aquí sólo se cambian los bloques marcados. */
document.addEventListener(ThemeEvents.variantUpdate, (e) => {
  const html = e.detail?.data?.html;
  if (!html) return;
  $$('[data-j4c-por-variante]').forEach((el) => {
    const nuevo = html.querySelector(`[data-j4c-por-variante="${el.dataset.j4cPorVariante}"]`);
    if (nuevo && nuevo.outerHTML !== el.outerHTML) el.replaceWith(document.importNode(nuevo, true));
  });
});

/* 2-nov: cambiar de grosor (60 ↔ 30) cuando la combinación no existe (p. ej. 30 den en S/M → 60 den no tiene S/M).
   Shopify devolvería la ficha sin color ni talla; aquí se abre la variante más cercana: mismo color y talla si existen,
   si no el mismo color, si no la primera disponible de ese grosor. */
document.addEventListener('change', (e) => {
  const input = e.target.closest?.('.j4c-den input');
  if (!input || input.dataset.variantId) return;
  const datos = $('[data-j4c-pack-data]');
  if (!datos) return;
  let data;
  try { data = JSON.parse(datos.textContent); } catch { return; }
  const di = data.options.findIndex((o) => /denier/i.test(o));
  const ci = data.options.findIndex((o) => /colou?r/i.test(o));
  const si = data.options.findIndex((o) => /size/i.test(o));
  const actual = data.variants.find((v) => String(v.id) === new URL(location.href).searchParams.get('variant'))
    || data.variants.find((v) => String(v.id) === $('j4c-buybox')?.dataset.variant);
  const del = data.variants.filter((v) => v.options[di] === input.value);
  const disp = del.filter((v) => v.available);
  const mismo = (v, i) => actual && v.options[i] === actual.options[i];
  const elegido = disp.find((v) => mismo(v, ci) && mismo(v, si)) || disp.find((v) => mismo(v, ci)) || disp[0] || del[0];
  if (!elegido) return;
  e.stopImmediatePropagation();
  const url = new URL(location.href);
  url.searchParams.set('variant', elegido.id);
  location.assign(url.toString());
}, true);
